import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Slices } from '../../constans/state';

export interface IUserData {
  access: string | null;
  refresh: string | null;
  lang: string | null;
  userId: string | null;
  langIsUpdating: boolean;
}

export interface IAuthSlice {
  userData: IUserData;
}

const userInitialState = {
  access: null,
  refresh: null,
  lang: null,
  userId: null,
  langIsUpdating: false,
  allowedSurveys: [],
};

interface IUpdateLang {
  langIsUpdating: boolean;
}

interface IUserIdLang {
  lang: string | null;
  userId: string | null;
  allowedSurveys: ('ADAPT' | 'PULSE' | 'EFFECT')[];
}

interface IUserLang {
  lang: string | null;
}

interface IUserTokens {
  access: string | null;
  refresh: string | null;
}

const initialState = {
  userData: userInitialState,
};

export const authSlice = createSlice({
  name: Slices.AuthSlice,
  initialState,
  reducers: {
    updateUserTokens: (state: IAuthSlice, action: PayloadAction<IUserTokens>) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    updateUserAccessToken: (state: IAuthSlice, action: PayloadAction<string>) => {
      state.userData.access = action.payload;
    },
    updateUserLangAndId: (state: IAuthSlice, action: PayloadAction<IUserIdLang>) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    updateUserLang: (state: IAuthSlice, action: PayloadAction<IUserLang>) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    manageLangUpdateState: (state: IAuthSlice, action: PayloadAction<IUpdateLang>) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    clearUserData: (state: IAuthSlice) => {
      state.userData = userInitialState;
    },
  },
});

export const {
  updateUserTokens,
  updateUserAccessToken,
  updateUserLangAndId,
  clearUserData,
  manageLangUpdateState,
  updateUserLang,
} = authSlice.actions;

export default authSlice.reducer;
